import { global_hooks } from '../../globals';

const SELECTOR_GROUP = '.process-spotlight';   // wrapper around the items
const SELECTOR_ITEM = '.process-item';
const ACTIVE_CLASS = 'is-active';
const INTERVAL_MS = 3200;

global_hooks.on('init', init);

function init() {
    const groups = document.querySelectorAll(SELECTOR_GROUP);
    if (!groups.length) return;

    groups.forEach(setupGroup);
}

function setupGroup(group) {
    const items = group.querySelectorAll(SELECTOR_ITEM);
    if (items.length < 2) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let index = 0;
    let timer = null;

    const activate = (i) => {
        items.forEach((item, n) => item.classList.toggle(ACTIVE_CLASS, n === i));
    };

    const advance = () => {
        index = (index + 1) % items.length;
        activate(index);
    };

    const start = () => {
        if (timer || reduceMotion) return;
        timer = setInterval(advance, INTERVAL_MS);
    };

    const stop = () => {
        clearInterval(timer);
        timer = null;
    };

    // first item starts active
    activate(0);
    if (reduceMotion) return; // honor reduced-motion: stay on item 1, no cycling

    // only run while the group is on screen (perf + correctness)
    if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => (entry.isIntersecting ? start() : stop()));
        }, { threshold: 0.1 });
        io.observe(group);
    } else {
        start();
    }

    // pause when the tab is hidden so it doesn't drift
    document.addEventListener('visibilitychange', () => {
        document.hidden ? stop() : start();
    });
}